<template>
    <v-app style="background-color: #f3f6f9">
        <v-main>
           
            <CreateManuiComp />
        </v-main>
    </v-app>
</template>
<script>
import Auth from '@/services/auth.service.js'
import CreateManuiComp from '@/components/seller/CreateManuiFirstComp.vue'
import SnackBar from '@/components/widgets/snackBar.vue'

export default {
    components: {
        CreateManuiComp,
    },
    data() {
        return {
        };
    },
    methods: {
    },
    computed: {
    },
    mounted() {
        document.title = 'הקמת מנוי | סים לחומרא'
        let auth = Auth.checkAuth();
        if (!auth) {
            return this.$router.replace({ name: "login" })
        }
    },
}
</script>
<style>
/* .container1 {
        width: 1000px; 
        margin: 0 auto; */
/* display: flex; */
/* flex-direction: column; */
/* justify-content: center; */
/* align-items: center; */
/* height: 100vh;  */
/* } */
</style>